import {createStore} from 'vuex'


export default createStore({
    state: {

        editableTabsValue: '/index',
        editableTabs: [
            {
                title: '首页',
                name: '/index',
                component: 'index'
            }
        ],

        componentStates: {},// 用于存储每个组件的状态
        keepInclude: [],
    },
    getters: {

    },
    mutations: {
        ADD_TABS: (state, tab) => {
            if (!tab || typeof tab !== 'object' || !tab.name || !tab.path) {
                console.error('ADD_TABS: 传入的 tab 参数无效');
                return;
            }

            // 确保 name 和 path 是字符串
            if (typeof tab.name !== 'string' || typeof tab.path !== 'string') {
                console.error('ADD_TABS: tab.name 和 tab.path 必须是字符串');
                return;
            }

            // 提取组件名，去除路径前后的斜杠
            const componentName = tab.path.replace(/^\/+|\/+$/g, '');

            // 查找 editableTabs 中是否存在同名 Tab
            if (state.editableTabs.findIndex(e => e.name === tab.path) === -1) {
                try {
                    state.editableTabs.push({
                        title: tab.name,
                        name: tab.path,
                        component: componentName
                    });
                    console.log('成功添加 Tab:', tab.path);
                } catch (error) {
                    console.error('添加 Tab 时出现错误:', error);
                }
            } else {
                console.log('Tab 已存在:', tab.path);
            }

            // 更新当前 editableTabsValue
            state.editableTabsValue = tab.path;
            console.log('更新当前 editableTabsValue:', state.editableTabsValue);
        },
        RESET_TAB: (state) => {
            state.editableTabsValue = '/index';
            state.editableTabs = [
                {
                    title: '首页',
                    name: '/index',
                    component: 'index'
                }
            ];
            // state.componentStates = {}; // 清空组件状态
            console.log('重置 Tab');
        },
        SET_ACTIVE_TAB: (state, path) => {
            state.editableTabsValue = path;
            console.log('设置当前活动 Tab:', path);
        },
        SET_COMPONENT_STATE: (state, {path, stateData}) => {
            state.componentStates[path] = stateData;
            console.log('设置组件状态:', path, stateData);
        },

    },
    actions: {
    },
    modules: {}
});
